import { useParams } from "react-router-dom";
import { ReportVersionsGrid } from "./ReportVersionsGrid";
import { DataTableMultiSortMetaType, DataTablePFSEvent, DataTableSortOrderType } from "primereact/datatable";
import { useState } from "react";
import { LOCALSTORAGE_KEYS } from "../shared/constants";
import { INITIAL_LAZY_GENERATED_REPORTS_STATE } from "../shared/constants/LazyStateGeneratedReportsConstants";

const sortFieldStorageKey = LOCALSTORAGE_KEYS.resultsSortField;
const sortOrderStorageKey = LOCALSTORAGE_KEYS.resultsSortOrder;

export function ReportVersionsViewer() {
  // Get the report document ID from the URL.
  const { reportDocumentId, customerId, companyId, siteId } = useParams<{
    reportDocumentId: string;
    customerId: string;
    companyId: string;
    siteId: string;
  }>();

  const [lazyState, setLazyState] = useState<DataTablePFSEvent>(() => {
    const field = (localStorage.getItem(sortFieldStorageKey) as string) ?? "created";
    const order = (localStorage.getItem(sortOrderStorageKey) as DataTableSortOrderType) ?? -1;
    const sort: DataTableMultiSortMetaType = [{ field: field, order: order }];

    return {
      ...INITIAL_LAZY_GENERATED_REPORTS_STATE,
      sortField: field,
      sortOrder: order,
      multiSortMeta: sort,
    };
  });

  const onFilter = (event: DataTablePFSEvent) => {
    event["first"] = 0;
    event["page"] = 1;
    setLazyState(event);
  };

  const onSort = (event: DataTablePFSEvent) => {
    event["page"] = lazyState.page;
    const field = event.multiSortMeta?.at(0)?.field as string;
    const order = event.multiSortMeta?.at(0)?.order ?? 0;
    localStorage.setItem(sortFieldStorageKey, field);
    order && localStorage.setItem(sortOrderStorageKey, order?.toString());
    event["sortField"] = field !== undefined ? field : "";
    event["sortOrder"] = order;
    setLazyState(event);
  };

  function onPage(event: DataTablePFSEvent) {
    event.page = (event.page ?? 0) + 1;
    setLazyState(event);
  }

  return (
    <ReportVersionsGrid
      reportDocumentId={Number(reportDocumentId)}
      customerId={Number(customerId)}
      companyId={Number(companyId)}
      siteId={Number(siteId)}
      lazyState={lazyState}
      onSort={onSort}
      onFilter={onFilter}
      onPage={onPage}
    />
  );
}
